import React from "react";
import { Button, Container, Form, Input, Label, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ViewGlobalProcedure = (props) => {
  const { onCloseModal, singleProcedure } = props;

  return (
    <div>
      <ModalHeader toggle={onCloseModal}>
        <h5>{'Visualizar Procedimento Global'}</h5>
      </ModalHeader>
      <ModalBody>
        <Container fluid={true}>
          <Form>
            <Label className="col-form-label">{"Código:"}</Label>
            <Input className="form-control" type="text" disabled defaultValue={singleProcedure.code}/>
            <Label className="col-form-label">{"Descrição:"}</Label>
            <Input className="form-control" type="text" disabled defaultValue={singleProcedure.description} />
            <Label className="col-form-label">{"Porte:"}</Label>
            <Input className="form-control" type="text" disabled defaultValue={singleProcedure.size.description} />
          </Form>
          <ModalFooter>
            <Button color="danger" className="float-right" onClick={() => onCloseModal()}>{'Fechar'}</Button>
          </ModalFooter>
        </Container>
      </ModalBody>
    </div>
  )
}

export default ViewGlobalProcedure;